import { Injectable, Provider } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { BehaviorSubject, Observable, delay, of, switchMap } from 'rxjs';
import { RequiredFields } from '../models/RequiredFields';
import { CreateLeadResponse, InternalLeadConfirmationModel, InternalLeadHeaderModel, InternalLeadSetupModel, InternalReferral, InternalReferringSource, InvolvedParty, localStorageIntoDB, ProviderList, StateCounty, StateNames } from '../models/vendor.model';
import { Questions } from '../models/Questions';
import { environment } from 'src/environments/environment';
import { InternalSubjectRequiredFieldsModel } from '../models/InternalSubjectRequiredFieldsModel';
import { Subject } from 'rxjs';
import { LOADING_ELEMENT } from './components/loading-spinner/loading-element.token';

@Injectable({
  providedIn: 'root'
})
export class VendorService {

  baseUrl = environment.baseUri;

  private fileUploadStartSubject: Subject<any> = new Subject<any>();
  private fileUploadEndSubject: Subject<any> = new Subject<any>();
  private fileUploadDataSubject: Subject<any> = new Subject<any>();
  uploadFiles: string[] = [];
  private storageKey = 'activeformdata';
  private dataSubject = new Subject<any>();
  filesReadyForUpload: any = [];
  FilesToUpload: any = [];
  
  constructor(private http: HttpClient) { }

  getFormData(): any {
    this.dataSubject.observers = [];
    return this.dataSubject.asObservable();
  }

  updateData(newData: any): void {
    sessionStorage.setItem(this.storageKey, JSON.stringify(newData));
    this.dataSubject.next(JSON.parse(JSON.stringify(newData)));
  }

  getSessionData() {
    return JSON.parse(sessionStorage.getItem("activeformdata") ?? "{}");
  }

  sendUploadStartData(data: any) {
    this.fileUploadStartSubject.next(data);
  }

  getUploadStartData(): Observable<any> {
    this.fileUploadStartSubject.observers = [];
    return this.fileUploadStartSubject.asObservable();
  }

  sendUploadEndData(data: any) {
    this.fileUploadEndSubject.next(data);
  }

  getUploadEndData(): Observable<any> {
    this.fileUploadEndSubject.observers = [];
    return this.fileUploadEndSubject.asObservable();
  }

  sendUploadFileData(data: any) {
    this.fileUploadDataSubject.next(data);
  }

  getUploadFileData(): Observable<any> {
    this.fileUploadDataSubject.observers = [];
    return this.fileUploadDataSubject.asObservable();
  }

  public getPayorIdByCode(securityCode: string | null): Observable<number> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.get<number>(this.baseUrl + "FCReferral/GetPayorIdByCode?securityCode=" + securityCode, { context: contextDetails });
  }

  public getRequiredFields(payorkey: number): Observable<RequiredFields> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.get<RequiredFields>(this.baseUrl + "FCReferral/GetRequiredFields?payorKey=" + payorkey, { context: contextDetails });
  }

  public getLeadPatientsTerm(payorkey: number): Observable<any> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.get<any>(this.baseUrl + "FCReferral/GetLeadPatientsTerm?payorKey=" + payorkey, { context: contextDetails });
  }

  public getInvolvedPartiesLookup(payorkey: number): Observable<InvolvedParty[]> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.get<InvolvedParty[]>(this.baseUrl + "FCReferral/GetInvolvedPartiesLookup?payorKey=" + payorkey, { context: contextDetails });
  }


  public getReferralTypesLookup(payorkey: number): Observable<InternalReferral[]> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.get<InternalReferral[]>(this.baseUrl + "FCReferral/GetReferralTypesLookup?payorKey=" + payorkey, { context: contextDetails });
  }

  public getReferringSourcesLookup(payorkey: number): Observable<InternalReferringSource[]> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.get<InternalReferringSource[]>(this.baseUrl + "FCReferral/GetReferringSourcesLookup?payorKey=" + payorkey, { context: contextDetails });
  }

  public getStateNames(): Observable<StateNames[]> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.get<StateNames[]>(this.baseUrl + "FCReferral/GetStates", { context: contextDetails });
  }
  public getStateCounties(isocode: string): Observable<StateCounty[]> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.get<StateCounty[]>(this.baseUrl + "FCReferral/GetStateCounties?isocode=" + isocode, { context: contextDetails });
  }
  public getLeadHeaders(payorkey: number): Observable<InternalLeadHeaderModel> {
    var contextDetails= new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.get<InternalLeadHeaderModel>(this.baseUrl + "FCReferral/GetLeadHeaders?payorKey=" + payorkey, { context: contextDetails });
  }

  public getLeadQuestion(payorkey: number): Observable<any> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.get<any>(this.baseUrl + "FCReferral/GetLeadQuestion?payorKey=" + payorkey, { context: contextDetails });
  }

  public getLeadConfirmation(payorkey: number): Observable<InternalLeadConfirmationModel> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.get<InternalLeadConfirmationModel>(this.baseUrl + "FCReferral/GetLeadConfirmation?payorKey=" + payorkey, { context: contextDetails });
  }

  public createLead(payorkey: number, data: any): Observable<CreateLeadResponse> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.post<CreateLeadResponse>(this.baseUrl + "FCReferral/CreateLead?payorKey=" + payorkey, data, { context: contextDetails });
  }

  public getLookUpProviderSpeciality(payorkey: number,): Observable<ProviderList[]> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.get<ProviderList[]>(this.baseUrl + "FCReferral/GetLookUpProviderSpeciality?payorKey=" + payorkey, { context: contextDetails });
  }
  public getLookUpProviderType(payorkey: number,): Observable<ProviderList[]> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.get<ProviderList[]>(this.baseUrl + "FCReferral/GetLookUpProviderType?payorKey=" + payorkey, { context: contextDetails });
  }

  public getLeadSetup(payorkey: number): Observable<InternalLeadSetupModel> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.get<InternalLeadSetupModel>(this.baseUrl + "FCReferral/GetLeadSetup?payorKey=" + payorkey, { context: contextDetails });
  }

  public getSubjectRequiredFieldsByInvolvedParty(internalInvolvedPartiesKey: number, payorkey: number): Observable<InternalSubjectRequiredFieldsModel> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.get<InternalSubjectRequiredFieldsModel>(this.baseUrl + "FCReferral/GetSubjectRequiredFieldsByInvolvedParty?payorKey=" + payorkey + "&internalInvolvedPartiesKey=" + internalInvolvedPartiesKey, { context: contextDetails });
  }

  public getInvolvedPartyById(internalInvolvedPartiesKey: number, payorkey: number): Observable<InvolvedParty> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.get<InvolvedParty>(this.baseUrl + "FCReferral/GetInvolvedPartyById?payorKey=" + payorkey + "&internalInvolvedPartiesKey=" + internalInvolvedPartiesKey, { context: contextDetails });
  }

  public addAttachmentToDB(data: any | null): Observable<number> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.post<number>(this.baseUrl + "FCReferral/AddAttachmentToDB", data, { context: contextDetails });
  }

  public commitLargeFiles(attachmentKey: any | null, fileName: any, totalChunks: any): Observable<number> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.get<number>(this.baseUrl + "FCReferral/CommitFile?attachmentKey=" + attachmentKey + "&fileName=" + fileName + "&totalChunks=" + totalChunks, { context: contextDetails });
  }

  public GetAttachmentStatus(data: any | null): Observable<any> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.post<any>(this.baseUrl + "FCReferral/GetAttachmentStatus", data, { context: contextDetails });
  }

  public pollStatus(interval: number, data: any | null): Observable<any> {
    return this.GetAttachmentStatus(data).pipe(switchMap(status => {
      if (status.filter((x: any) => x.VirusScanStatus == null || x.VirusScanStatus == 0).length == 0) {
        return of(status);
      }
      else {
        return of(status).pipe(delay(interval), switchMap(() => this.pollStatus(interval, data)));
      }
    }));
  }

  public generateCode(contactEmail: string | null) {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.post<{ code: string, message: string }>(this.baseUrl + "EmailAuth/GenerateCode", { contactEmail }, { context: contextDetails });
  }

  public validateCode(data: { authCode: string; email: string }): Observable<boolean> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.post<boolean>(this.baseUrl + "EmailAuth/ValidateCode", data, { context: contextDetails });
  }

  public verifyReferralCode(securityCode: string | null): Observable<number> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.get<number>(this.baseUrl + "FCReferral/VerifyReferralCode?securityCode=" + securityCode, { context: contextDetails });
  }

  public sendReferralEmail(data:any): Observable<any> {
    var contextDetails = new HttpContext().set(LOADING_ELEMENT, 'body');
    return this.http.post<any>(this.baseUrl + "FCReferral/SendReferralEmail", data, { context: contextDetails });
  }

}

